import ContactsDataTable from "../../../components/dataTable/tables/ContactsDataTable";

function ContactsPageView() {
  return <ContactsDataTable />;
}

export default ContactsPageView;
